import { XR_EXPERIENCES } from '../data/xr-experiences';

/**
 * Recommend experiences based on saved content.
 * Uses content-based filtering: same category, overlapping tags.
 * @param {string[]} savedIds
 * @param {number} limit
 * @param {Object[]} experiencesList - optional; merged list (static + Firestore). If omitted, uses XR_EXPERIENCES.
 */
export function getRecommendations(savedIds, limit = 12, experiencesList = null) {
  const list = experiencesList ?? XR_EXPERIENCES;
  const getExp = (id) => (list.find((e) => e.id === id) || null);

  if (!savedIds || savedIds.length === 0) {
    return list.slice(0, limit);
  }

  const savedSet = new Set(savedIds);
  const savedExperiences = savedIds.map((id) => getExp(id)).filter(Boolean);

  const categoryCounts = {};
  const tagCounts = {};
  for (const exp of savedExperiences) {
    categoryCounts[exp.category] = (categoryCounts[exp.category] || 0) + 1;
    for (const tag of exp.tags || []) {
      tagCounts[tag] = (tagCounts[tag] || 0) + 1;
    }
  }

  const scored = list
    .filter((exp) => !savedSet.has(exp.id))
    .map((exp) => {
      let score = 0;
      score += (categoryCounts[exp.category] || 0) * 3;
      for (const tag of exp.tags || []) {
        score += (tagCounts[tag] || 0) * 2;
      }
      if (exp.contentType) {
        const savedTypes = savedExperiences.map((e) => e.contentType).filter(Boolean);
        if (savedTypes.includes(exp.contentType)) score += 1;
      }
      return { exp, score };
    })
    .filter((x) => x.score > 0)
    .sort((a, b) => b.score - a.score)
    .map((x) => x.exp);

  if (scored.length >= limit) return scored.slice(0, limit);
  const remaining = list.filter((exp) => !savedSet.has(exp.id) && !scored.includes(exp));
  return [...scored, ...remaining].slice(0, limit);
}
